// This is an instance of the scokets api interface, its expected to be used externally
window.cxSocketApi = null

// This is a queue that stores all requests sent before connection is made to the server
let pendingRequests = null;
let apiResponseQueue = null;

// This is a global variable that gets updated with true when a 
// connection is successfully made to the server and with false when connection drops
let cxClientConnected = false;
let isProcessingResponse = false;

// This is the total number of tries since connection droped
let tries = 0;

let globalUrl;

let globalRefreshTokenName;
let globalTokenName;
let failedRequestsDueToAbnormalError = [];
let failureNotificationSent = false;
// This code is responsible for generating the client_id and id for the request.
function generateUuid() {
    const chars = '0123456789abcdef'.split('');
    let uuid = [], rnd = Math.random, r;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4'; // version 4
    for (let i = 0; i < 36; i++) {
        if (!uuid[i]) {
            r = 0 | rnd() * 16;
            uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r & 0xf];
        }
    }
    return uuid.join('');
}
// if (jsonData?.channel) {
//     const channel = this.getChannelName(jsonData.channel)
//     const subscriberCallback = subscriptions[channel]
//     if (subscriberCallback) {
//         subscriberCallback(jsonData)
//     }
// }
// This class represents the ConnectXone Socket API Interface, 
// it exposes functions that allows the web client to talk to the server
class CxOneSocketApi {
    constructor(cxOneClientId, cxApi, totalTries, url, refreshTokenName, tokenName) {
        this.cxOneClientId = cxOneClientId;
        this.totalTries = totalTries;
        this.cxApi = cxApi;
        this.url = url;
        this.callbacks = [];
        this.refreshingToken = false;
        this.tokenName = tokenName;
        this.refreshTokenName = refreshTokenName;
        this.listenForResponses();
    }

    runProccessors(){
        this.consumeRequestsFromQueue()
        this.processResponses()
    }
    consumeRequestsFromQueue() {
        while (pendingRequests.size() > 0) {
            pendingRequests.dequeue()();
        }
    }
    getChannelName(channel) {
        let channelName = channel?.name
        if (channel?.id) {
            channelName = `${channelName}_${channel.id}`
        }
        return channelName
    }
    // listens for new messages from the sockets server
    listenForResponses() {
        this.cxApi.onopen = () => {
            failureNotificationSent = false;
            cxClientConnected = true;
            
            this.runProccessors();
            if (failedRequestsDueToAbnormalError) {
                for (let index in failedRequestsDueToAbnormalError) {
                    const callback = failedRequestsDueToAbnormalError[index];
                    if (!!callback?.action) {
                        this.talk(callback?.action, callback?.onSuccess, callback?.onFailure, callback?.payload);
                    } else {
                        console.log("Skipping request due to invalid action name")
                    }
                }
                failedRequestsDueToAbnormalError = [];
            }
            if (window.onConnectionStateChanged) {
                window.onConnectionStateChanged("connected");
            }
        }
        this.cxApi.onclose = (error) => {
            if (error.code === 1006) {
                this.callbacks.forEach((c) => {
                    failedRequestsDueToAbnormalError.push(c)
                })
                this.callbacks = [];
            }
            cxClientConnected = false;
            console.error(`Connection Closed...Retrying (${tries})`)
            // check if user has set max retries, if so, only try that much times
            const initializer = new ConnectxoneInitializer()
            if (this.totalTries === null) {
                // only try connecting if cleint is not connected.
                if (!cxClientConnected) {
                    initializer.cxOneConnect(this.url, this.totalTries, this.tokenName, this.refreshTokenName)
                }
                if (window.onConnectionStateChanged && !failureNotificationSent) {
                    window.onConnectionStateChanged("disconnected");
                }
            } else {
                if (tries <= this.totalTries && !cxClientConnected) {
                    initializer.cxOneConnect(this.url, this.totalTries, this.tokenName, this.refreshTokenName)
                }
            }
            failureNotificationSent = true;
        }
        this.cxApi.onerror = () => {
            cxClientConnected = false;
        }
        this.cxApi.onmessage = (message) => {
            const jsonData = JSON.parse(message.data)
            apiResponseQueue.enqueue(jsonData)
            this.processResponses()
        }

    }

    processResponses(){
            if(!isProcessingResponse){
                isProcessingResponse = true
                while(apiResponseQueue.size()>0){
                    const jsonData = apiResponseQueue.dequeue()
                        // Loop through callbacks and find callbacks registered with the request id found in this reponse
                        // remove callback from list after it has been called
                        // This can be optimized if need be, a set data structure can be used.
                        for (let i in this.callbacks) {
                            const callback = this.callbacks[i]
                            if (callback.id === jsonData?.id) {
                                // if request was successful, call success callback else call failure callback
                                if (jsonData.client_id === this.cxOneClientId &&
                                    +jsonData?.code >= 200 && +jsonData?.code < 300) {
                                    callback.onSuccess(jsonData)
                                } else {
                                    if (+jsonData.code === 401) {
                                        // failedRequestsDueToInvalidToken.push(callback);
                                        if (!this.refreshingToken) {
                                            const refreshToken = localStorage.getItem(globalRefreshTokenName)
                                            this.refreshingToken = true;
                                            this.talk("refresh-token", (res) => {
                                                this.refreshingToken = false;
                                                localStorage.setItem(globalTokenName, res.data)
                                                // refresh token is currently added to the list of callbacks so remove it
                                                this.callbacks.splice(this.callbacks.length-1, 1)
                                                const callbacksToRetry = [...this.callbacks];
                                                apiResponseQueue.clear()
                                                this.callbacks =[];
                                                for (let index in callbacksToRetry) {
                                                    const cb = callbacksToRetry[index];
                                                    this.talk(cb?.action, cb?.onSuccess, cb?.onFailure, cb?.payload);
                                                }
                                            }, (err) => {
                                                this.refreshingToken = false;
                                                if (window.onConnectionStateChanged) {
                                                    window.onConnectionStateChanged("token-expired");
                                                }
                                            }, refreshToken)
                                        }
                                        break
                                    } else {
                                        callback.onFailure(jsonData)
                                    }
                                }
                                this.callbacks.splice(i, 1)
                                break
                            }
                        }
                }
                isProcessingResponse = false
            }
    }
    
    // This is the implementation that sends the request
    submitRequest(action, onSuccess, onFailure, data = null) {
        // generate a unique request id
        const id = generateUuid();
        // lookup token using provided localstorage key
        const token = localStorage.getItem(this.tokenName)
        // request must contain the following:
        // 1) An Id to uniquely identify the request
        // 2) A client id to uniquely identify the user agent sending the request
        // 3) An action, the name of the action to perform on the server
        // 4) An optional request data/payload
        // 5) An optional token if the request needs to be authenticated
        const payload = {
            id,
            client_id: this.cxOneClientId,
            action,
            parameter: data,
            token
        }
        // Sends request through the existing websocket connection
        this.cxApi.send(JSON.stringify(payload))

        // push success and failure callbacks with request id to callbacks array.
        // The request id helps identify which sets of callbacks(success & failure) 
        // to call with a specific response data, every response contains the request id
        this.callbacks.push({ action, id, onSuccess, onFailure, payload: data })
    }

    // sends a request to the socket api using submitRequest
    talk(action, onSuccess, onFailure, data = null) {
        // If client is connected to server, send request
        if (cxClientConnected) {
            this.submitRequest(action, onSuccess, onFailure, data)
        } else {
            // add request to queue if client is not connected
            pendingRequests.enqueue(() => { this.submitRequest(action, onSuccess, onFailure, data) })
        }
    }
    // subscribe for continuous updates
    // subscribe(onMessage, onSuccess, onFailure, channel) {
    //     const cxOneClientId = generateUuid();
    //     const conn = new WebSocket(`${globalUrl}/${cxOneClientId}`)
    //     conn.onopen = () => {
    //         onSuccess("Connected Successfully")
    //         const id = generateUuid();
    //         // lookup token using provided localstorage key
    //         const token = localStorage.getItem(globalTokenName)
    //         const payload = {
    //             id,
    //             client_id: cxOneClientId,
    //             action: "subscribe",
    //             parameter: channel,
    //             token
    //         }
    //         conn.send(JSON.stringify(payload))
    //         conn.onmessage = onMessage
    //     }
    //     conn.onerror = (error) => {
    //         console.log(error)
    //         onFailure("Failed to subscribe to channel")
    //     }
    //     // If client is connected to server, send request
    //     // if (cxClientConnected) {
    //     //     subscriptions[this.getChannelName(channel)] = onMessage
    //     //     this.submitRequest("subscribe", onSuccess, onFailure, { name: "", id: null, ...channel })
    //     // } else {
    //     //     // add request to queue if client is not connected
    //     //     pendingRequests.enqueue(() => {
    //     //         subscriptions[this.getChannelName(channel)] = onMessage
    //     //         this.submitRequest("subscribe", onSuccess, onFailure, { name: "", id: null, ...channel })
    //     //     })
    //     // }
    // }
}

// This class is basically responsible for intializing the Socket API Interface
export class ConnectxoneInitializer {
    cxOneConnect(url, totalTries = null, tokenName = "token", refreshTokenName = "refresh_token") {
        globalUrl = url
        globalTokenName = tokenName
        globalRefreshTokenName = refreshTokenName
        pendingRequests = new RequestQueue()
        apiResponseQueue = new RequestQueue();
        // generate new client id to establish a new connection to the server
        const cxOneClientId = generateUuid();
        tries++;
        const cxApi = new WebSocket(`${url}/${cxOneClientId}`)
        registerServiceWorker();
        // create an instance of the Socket API Interface
        window.cxSocketApi = new CxOneSocketApi(cxOneClientId, cxApi, totalTries, url, refreshTokenName, tokenName)

    }
}

// This is an implementation of a Queue, 
// found on https://stackoverflow.com/questions/45704512/javascript-queue-native and modified
class RequestQueue {
    constructor() {
        this.oldestIndex = 1;
        this.newestIndex = 1;
        this.storage = {};
    }

    clear(){
        this.storage = {}
    }
    size() {
        return this.newestIndex - this.oldestIndex;
    }

    enqueue(data) {
        this.storage[this.newestIndex] = data;
        this.newestIndex++;
    }

    dequeue() {
        var oldestIndex = this.oldestIndex,
            newestIndex = this.newestIndex,
            deletedData;

        if (oldestIndex !== newestIndex) {
            deletedData = this.storage[oldestIndex];
            delete this.storage[oldestIndex];
            this.oldestIndex++;

            return deletedData;
        }
    }
}

const registerServiceWorker = async (swPath) => {
    if ("serviceWorker" in navigator && swPath) {
        try {
            const registration = await navigator.serviceWorker.register(swPath, {
                scope: "/",
            });
            if (registration.installing) {
                console.log("Service worker installing");
            } else if (registration.waiting) {
                console.log("Service worker installed")
            } else if (registration.active) {
                console.log("Service worker active")
            }
        } catch (error) {
            console.error(`Registration failed with ${error}`)
        }
    }
}